// Common
export const apiGetSystemKey = '/api/systemKey/getAll'
